import type {
  SmsStatusPayload,
  UpdateBusinessDescriptorPayload,
  UpdateInvoiceAppearancePayload,
  UpdateInvoiceParametersPayload,
  UpdateLegalHeadquartersPayload,
  UpdateLegalIdentityPayload,
  UpdateLegalNumbersPayload,
  UpdateNotificationsPayload,
  UpdateOrganizationPayload,
  UpdateTravelFeesPayload,
} from "@mytour/shared";
import axios from "axios";

export const companySettingsApiService = {
  // Billing
  async updateTravelFees(payload: UpdateTravelFeesPayload): Promise<void> {
    await axios.post("api/platform-users/billing/travel-fees/", payload);
  },

  async updateLegalIdentity(payload: UpdateLegalIdentityPayload): Promise<void> {
    await axios.post("api/platform-users/billing/legal-identity/", payload);
  },

  async updateLegalHeadquarters(payload: UpdateLegalHeadquartersPayload): Promise<void> {
    await axios.post("api/platform-users/billing/legal-headquarters/", payload);
  },

  async updateLegalNumbers(payload: UpdateLegalNumbersPayload): Promise<void> {
    await axios.post("api/platform-users/billing/legal-numbers/", payload);
  },

  async updateInvoiceAppearance(payload: UpdateInvoiceAppearancePayload): Promise<void> {
    await axios.post("api/platform-users/billing/invoice-appearance/", payload);
  },

  async updateInvoiceParameters(payload: UpdateInvoiceParametersPayload): Promise<void> {
    await axios.post("api/platform-users/billing/invoice-parameters/", payload);
  },

  // My Business
  async updateBusinessDescriptor(payload: UpdateBusinessDescriptorPayload): Promise<void> {
    await axios.post("api/platform-users/business/descriptor/", payload);
  },

  async updateOrganization(payload: UpdateOrganizationPayload): Promise<void> {
    await axios.post("api/platform-users/business/organization/", payload);
  },

  // Notifications
  async updateNotifications(payload: UpdateNotificationsPayload): Promise<void> {
    await axios.post("api/platform-users/notifications/", payload);
  },

  // SMS
  async getSmsStatus(): Promise<SmsStatusPayload> {
    const result = await axios.get<SmsStatusPayload>(
      "api/platform-users/notifications/sms-status"
    );
    return result.data;
  },
};
